// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__23rFV","right":"styles_right__thv19"};